<template>
  <div class="card--container--ticket">
    <color-label :colorId="cardData.colorId" :ticketId="cardData.delivery.id" :colorArray="colorArray"></color-label>

    <b-button class="ticket--card" variant="link" @click="goToTicket" :style="styleCard">
      <div class="ticket--card--head" :style="styleCardHead">
        <h1 class="h5 m-0"><p class="text--title"  :style="styleCardTitle">{{cardData.current_status.client_name}}</p></h1>
      </div>
      <div class="ticket--card--body">
        <p class="m-0">
          <span>OT {{trackingNumber}} / Ref. {{importedId}}</span>
        </p>
      </div>
    </b-button>
  </div>
</template>

<script>
import colorLabel from '@/views/modules/tickets/components/List/colorLabel.vue'

export default {
  props: ['cardData', 'colorArray'],
  components: { colorLabel },
  computed: {
    trackingNumber() {
      return this.cardData?.delivery?.tracking_number || ''
    },
    importedId() {
      return this.cardData?.delivery?.imported_id || ''
    },
    styleCard() {
      return {
        borderColor: this.cardData.borderColor,
        backgroundColor: this.cardData.read_by_user ? '#E3EAED' : '#FFF'
      }
    },
    styleCardHead() {
      return {
        borderColor: this.cardData.read_by_user ? '#6E6B7B' : '#E48E3F'
      }
    },
    styleCardTitle() {
      return {
        color: this.cardData.read_by_user ? '#6E6B7B' : '#E48E3F'
      }
    }
  },
  methods: {
    goToTicket() {
      this.$bvModal.show('ModalTicketID')
      this.$emit('ticketId', this.cardData.delivery.id)
    }
  }
}
</script>

<style lang="scss">
.ticket--card {
  width: 100%;
  height: fit-content;
  background: #FFF;
  border-radius: 10px;
  border: 1px solid #044389;
  border-left: 15px solid #ffffff;
  padding: 10px;
  text-align: left;
  box-shadow: 0px 16px 24px 0px #00000024;

  .ticket--card--head {
    text-transform: capitalize;
    border-bottom: 1px solid #E48E3F;
    max-width: 80%;
  }
  .ticket--card--body {
    color: #5E5873;
    margin: 8px auto;
    p {
      font-size: 12px;
      line-height: normal;
    }
  }
  .text--title {
    font-weight: 700;
    color: #E48E3F;
    font-size: 12px;
    text-transform: lowercase;
    margin: 0;
    line-height: normal;
  }
  p.text--title::first-letter {
    text-transform: uppercase;
  }
}

</style>
